export default {
  styleOverrides: {
    root: {
      padding: '0',
      '&:last-child': {
        padding: '0',
      },
    },
  },
};
